var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.2364V11.7636L24.21 11.0649C23.9903 10.2966 23.6824 9.55624 23.2923 8.8588L25.1273 6.03695L21.9641 2.87368L19.1422 4.70872C18.4452 4.31741 17.7044 4.00993 16.9351 3.7927L16.2364 0.5H11.7636L11.0649 3.79003C10.2966 4.00965 9.55624 4.31757 8.85879 4.70772L6.03695 2.87268L2.87368 6.036L4.70872 8.85785C4.31858 9.5553 4.01066 10.2956 3.79103 11.064L0.5 11.7636V16.2364L3.7927 16.9351C4.00926 17.7039 4.31596 18.4444 4.70643 19.1413L2.87139 21.9631L6.03466 25.1264L8.85651 23.2913C9.55396 23.6815 10.2943 23.9894 11.0626 24.209L11.7636 27.5001H16.2364L16.9351 24.2074C17.7034 23.9891 18.4437 23.6825 19.1413 23.2936L21.9631 25.1287L25.1264 21.9654L23.2913 19.1435C23.6811 18.4454 23.9886 17.7043 24.2074 16.9351L27.5 16.2364ZM14.002 19.8218C10.7867 19.8229 8.1793 17.2173 8.17818 14.002C8.17707 10.7867 10.7827 8.1793 13.998 8.17818C17.2133 8.17707 19.8207 10.7827 19.8218 13.998C19.8224 17.2131 17.217 19.8202 14.002 19.8218Z",
    fill: "#585757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.30c7b38703106f187be4977b99d73258.svg";
export { ForwardRef as ReactComponent };